import * as React from 'react'
import * as PopoverPrimitive from '@radix-ui/react-popover'
import { cn } from '@/lib/utils'

export const Popover = PopoverPrimitive.Root
export const PopoverTrigger = PopoverPrimitive.Trigger
export const PopoverAnchor = PopoverPrimitive.Anchor
export const PopoverClose = PopoverPrimitive.Close

export const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, align = 'center', sideOffset = 6, onWheel, onTouchMove, ...props }, ref) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      collisionPadding={8}
      // Popover mở từ trong hộp thoại (Dialog modal) nằm NGOÀI cây của hộp thoại → hộp thoại chặn cuộn chuột / cảm ứng,
      // danh sách trong popover chỉ kéo được thanh cuộn. Chặn sự kiện nổi lên document để cuộn bình thường.
      onWheel={(e) => {
        e.stopPropagation()
        onWheel?.(e)
      }}
      onTouchMove={(e) => {
        e.stopPropagation()
        onTouchMove?.(e)
      }}
      className={cn(
        'z-50 rounded-lg border bg-popover p-4 text-popover-foreground shadow-lg outline-none animate-fade-in',
        className,
      )}
      {...props}
    />
  </PopoverPrimitive.Portal>
))
PopoverContent.displayName = 'PopoverContent'
